export const language = {
	pt: {
		// Geral / Títulos
		component: 'Temporadas',
		component_new: 'Nova Temporada',
		component_edit: 'Editar Temporada',
		component_list: 'Listagem',

		// Campos
		field_name: 'Nome',
		field_tag: 'Tag',
		field_activo: 'Temporada atual',
		field_avaiable: 'Disponível',

		color_primary: 'Cor Primária',
		color_secondary: 'Cor Secundária',
		color_placeholder: 'Selecione uma cor',

		// Botões
		back: 'Voltar',
		delete: 'Eliminar',
		save: 'Guardar',
		add_new: 'Nova Temporada',

		// Inserir
		insert_title: 'Inserir Temporada',
		insert_text: 'Deseja inserir esta temporada?',
		insert_confirm: 'Sim, inserir',
		insert_cancel: 'Cancelar',
		insert_error: 'Erro ao inserir a temporada!',

		// Editar
		edit_title: 'Editar Temporada',
		edit_text: 'Deseja guardar as alterações desta temporada?',
		edit_confirm: 'Sim, guardar',
		edit_cancel: 'Cancelar',
		edit_error: 'Erro ao editar a temporada!',

		// Eliminar
		delete_title: 'Eliminar Temporada',
		delete_text: 'Deseja eliminar esta temporada? Esta ação não pode ser revertida.',
		delete_confirm: 'Sim, eliminar',
		delete_cancel: 'Cancelar',

		// Tabela (DataTable)
		table_rows_per_page: 'Registos por página',
		table_separator: 'de',
		table_all: 'Todos',
		table_empty: 'Não existem temporadas registadas',
		filter_placeholder: 'Pesquisar...',
	},
	en: {
		// General / Titles
		component: 'Seasons',
		component_new: 'New Season',
		component_edit: 'Edit Season',
		component_list: 'List',

		// Fields
		field_name: 'Name',
		field_tag: 'Tag',
		field_activo: 'Current season',
		field_avaiable: 'Available',

		color_primary: 'Primary Color',
		color_secondary: 'Secondary Color',
		color_placeholder: 'Select a color',

		// Buttons
		back: 'Back',
		delete: 'Delete',
		save: 'Save',
		add_new: 'New Season',

		// Insert
		insert_title: 'Insert Season',
		insert_text: 'Do you want to insert this season?',
		insert_confirm: 'Yes, insert',
		insert_cancel: 'Cancel',
		insert_error: 'Error inserting the season!',

		// Edit
		edit_title: 'Edit Season',
		edit_text: 'Do you want to save the changes to this season?',
		edit_confirm: 'Yes, save',
		edit_cancel: 'Cancel',
		edit_error: 'Error editing the season!',

		// Delete
		delete_title: 'Delete Season',
		delete_text: 'Do you want to delete this season? This action cannot be undone.',
		delete_confirm: 'Yes, delete',
		delete_cancel: 'Cancel',

		// Table (DataTable)
		table_rows_per_page: 'Rows per page',
		table_separator: 'of',
		table_all: 'All',
		table_empty: 'No seasons found',
		filter_placeholder: 'Search...',
	}
}